import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../Models/RootStore'
import makeStyles from '@mui/styles/makeStyles'
import { Title, Button } from '../../../Components'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '44rem',
    [theme.breakpoints.down('xl')]: {
      maxWidth: '38rem'
    }
  },
  description: {
    marginBottom: '2rem'
  },
  button: {
    minHeight: '3.125rem',
    marginTop: '0.5rem',
    marginBottom: '1.75rem'
  }
}))

const EmailChange = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { sessionStore }: any = useStore()

  let initialCode = ''
  if (window.location.search) {
    const parts = window.location.search.split('code=')
    if (parts.length > 1 && parts[1].split('&')[0].length === 36) {
      initialCode = parts[1].split('&')[0]
    }
  }

  useEffect(() => {
    if (initialCode) {
      sessionStore.getEmailChange(initialCode)
    }
  }, [])

  const verifyEmailChange = () => sessionStore.verifyEmailChange(initialCode)

  const getDescription = () => {
    if (sessionStore.loading) return null
    if (sessionStore.emailChange) {
      return sessionStore.emailChange.email
    } else {
      return t('invalid_or_expired_code_description')
    }
  }

  const renderVerifyEmailButton = () => {
    if (initialCode && !!sessionStore.emailChange) {
      return (
        <Button
          text={t('verify')}
          onClick={verifyEmailChange}
          buttonStyle={classes.button}
          fullWidth
        />
      )
    }
    return null
  }

  return (
    <div className={classes.root}>
      <Title
        title={t('verify_email_change')}
        description={getDescription()}
        type='main'
        descriptionStyle={classes.description}
      />
      {renderVerifyEmailButton()}
    </div>
  )
}

export default observer(EmailChange)
